import React from "react";
import pdfContext from "./support/PdfContext";
import QuotationButton from "../buttons/QuotationButton";

function QrCreator(props) {
    const {triggerPdfGeneration} = React.useContext(pdfContext)

    const handleClick = () => {
        triggerPdfGeneration({reportType: props.reportType, reportId: props.id, version: props.version})
    }

    return (
        <div>
            <QuotationButton label={props.label} onClick={handleClick}/>
        </div>
    )
}

export default QrCreator
